<template>
	<div class="min-vh-100 pb-5">
		<div class="" v-if="event">
			<div class="d-flex">
				<div class="font-size-h3 flex-grow-1"><template v-if="event.client.addressname"> - {{event.client.addressname}}</template></div>
				<div class="text-secondary font-weight-bold  align-self-center">
					{{getDay(event.start)}} {{getMonth(event.end)}}
					{{event.start | formatTime}} - {{event.end | formatTime}}
				</div>
			</div>
			<p class="mb-0" v-if="event.typelibelle">{{event.typelibelle}}</p>
			<p v-if="event.title"v-html="$options.filters.nl2br(event.title)"></p>
			<div class="row" v-if="event.client.address">
				<div class="col py-1">
					<link-address
							v-model='event.client.address+" "+event.client.city'>
						{{event.client.address}}<br>
						{{event.client.zipcode}} {{event.client.city}}
					</link-address>
				</div>
			</div>
			<p class="mb-0" v-if="event.client.contact_astreinte" ><b>Contact d'astreinte : </b>{{ event.client.contact_astreinte }}</p>
			<p class="mb-0" v-if="event.client.consignes" ><b>Consignes particulières : </b>{{ event.client.consignes }}</p>


			<div class="border-top border-light border-2 mt-4 mb-3"></div>
			<div v-if="event.comment" class="font-size-h4 font-weight-bold">{{$t('Work order')}}</div>
			<p v-if="event.comment" v-html="$options.filters.nl2br(event.comment)"></p>

      <template v-if="event.state=='terminée'">
        <!-- verifier l'état de l'event, si terminée dans eko; on n'affiche pas le bouton -->
        <div  class="font-size-h4 font-weight-bold text-success">
          <i class="fas fa-check text-success"></i>
          {{$t('Finished')}}</div>

        <a href="#" @click.prevent="router().back()" class="btn btn-block btn-primary mt-5" >{{$t('Back')}}</a>
      </template>

      <template v-else>

        <div v-if="event.imperatifs&&event.imperatifs.length" class="font-size-h4 font-weight-bold">{{$t('Imperative(s)')}} <span class="text-danger font-size-base font-italic" v-if="!allImperatifChecked">{{$t('Please check all the imperatives')}}</span> </div>
        <div v-if="event.imperatifs&&event.imperatifs.length">
          <div class="custom-control custom-checkbox" v-for="(imperatif, k) in event.imperatifs">
            <input :id="`imperatif-`+k" type="checkbox" class="custom-control-input" :checked="intervention.imperatifs[imperatif]" @change="clickImperatif(imperatif)">
            <label :for="`imperatif-`+k" class="custom-control-label">{{imperatif}}</label>
          </div>
        </div>

        <a href="#" @click.prevent="showVehicles" :disabled="!allImperatifChecked" class="btn btn-block btn-primary mt-5" :class="{disabled: !allImperatifChecked}">{{$t('Start the intervention')}}</a>
      </template>
		</div>

        <br>
	</div>
</template>


<script>
	
	// @ is an alias to /src
	import {mapGetters, mapActions} from 'vuex'
	import LinkAddress from '@/components/LinkAddress.vue';
  import router from "@/router";
	
	export default {
		name: 'event',
		props: ['eventid'],
		components: {
			LinkAddress
		},
		mounted () {
			this.setPageTitle(this.event.client.name);
		},
		computed: {
			// mix the getters into computed with object spread operator
			...mapGetters('events', [
				'getEvent'
			]),
			...mapGetters('interventions', [
				'getIntervention'
			]),
			// vérifie si tous les impératifs sont bien cochés
			allImperatifChecked(){
				let allcheckeds = true;
				let self = this;
				_.forEach(this.event.imperatifs,  (imperatif) => {
					allcheckeds = allcheckeds && self.intervention.imperatifs[imperatif];
				});
				return allcheckeds;
			},
		},
		beforeMount: function () {
			this.event = this.getEvent(this.eventid);
			this.intervention = this.getIntervention(this.eventid);
		},
		data: function () {
			return {
				event: {},
				intervention: {},
			}
		},
        methods: {
          router() {
            return router
          },
			...mapActions('interventions', ['checkImperatif', 'uncheckImperatif']),
			...mapActions('config', ['setPageTitle']),
            showVehicles(){
			    this.$router.push({name: 'vehicles', params:{eventid: this.eventid}});
            },
			getDay(date){
				return moment(date).format('D');
			},
			getMonth(date){
				return moment(date).format('MMM');
			},
			clickImperatif(imperatif){
				if (!this.intervention.imperatifs){
					this.$set(this.intervention, 'imperatifs', {});
				}
				if (this.intervention.imperatifs[imperatif]){
					this.$set(this.intervention.imperatifs, imperatif, 0);
					this.uncheckImperatif({uid: this.eventid, data: imperatif});
				} else {
					this.$set(this.intervention.imperatifs, imperatif, 1);
					this.checkImperatif({uid: this.eventid, data: imperatif});
				}
			}
        }
	}
</script>

<style>
	.block-content.info {
		border: none;
		border-left: 1px solid black;
		border-left-width: 10px;
		border-radius: 0;
		margin-bottom: 5px;
	}
</style>
